const COMMENTS = [
  {
    name: '影迷小陈',
    avatar: '陈',
    text: '91精品影视真的太棒了！资源更新速度超快，画质一直都是高清，看片一点都不卡，完全不缓冲。已经推荐给身边所有朋友了，91影视在线看片体验一流。',
    tag: '忠实用户',
    time: '3天前',
  },
  {
    name: '追剧达人',
    avatar: '达',
    text: '用了大半年了，91精品影视免费观看真的很良心。资源库特别全，想看的电影电视剧基本都能找到。高清流畅不卡顿，是真正的91影视看片免费首选平台。',
    tag: '资深影迷',
    time: '1周前',
  },
  {
    name: '电影控',
    avatar: '影',
    text: '之前试过好多在线看片网站，要么要收费要么卡得要命。91精品影视完全免费不说，清晰度和流畅度都远超预期，不缓冲不卡顿，真心推荐给大家！',
    tag: '新用户',
    time: '2周前',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">用户热评</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            听听真实用户怎么说
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {COMMENTS.map((c) => (
            <div
              key={c.name}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-300/30"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center text-primary-400 font-bold text-sm">
                  {c.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-100">{c.name}</div>
                  <div className="text-xs text-foreground-500">{c.time}</div>
                </div>
                <span className="ml-auto px-2 py-0.5 text-[10px] font-medium rounded-full bg-secondary-500/15 text-secondary-400 whitespace-nowrap">
                  {c.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">&ldquo;{c.text}&rdquo;</p>
              <div className="flex items-center gap-1 mt-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-primary-400 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}